export const current = 'GDZL'; // 当前平台代理商

export const AGENTPLATIDMAP = new Map([
  ['GDZL', 1001],
  ['CLGJ', ''],
]);

export const AGENTPLATID = AGENTPLATIDMAP.get(current);

// "message": "　　请你务必审慎阅读、充分理解“服务协议”和“隐私政策”各条款，包括但不限于：为了更好的向你提供服务，我们需要收集你的设备标识、操作日志等信息用于分析、优化应用性能。<br/>　　您可阅读<a href=\"https://agreement.ceekee.com/#/pages/ceekee/serviceAgreement\">《服务协议》</a>和<a href=\"https://agreement.ceekee.com/#/pages/ceekee/privacyPolicy\">《隐私政策》</a>了解详细信息。如果你同意，请点击下面按钮开始接受我们的服务。",

//"message": "　　进入应用前，您需先同意<a href=\"https://agreement.ceekee.com/#/pages/ceekee/serviceAgreement\">《服务协议》</a>和<a href=\"https://agreement.ceekee.com/#/pages/ceekee/privacyPolicy\">《隐私政策》</a>，否则将退出应用。",
